export default __webpack_public_path__ + "static/media/chats_icon.4df8e15e.svg";